"use client";

import { ChevronRight } from "lucide-react";
import { Button } from "@/shadcn-components/ui/button";
import { Card, CardContent } from "@/shadcn-components/ui/card";
import { Badge } from "@/shadcn-components/ui/badge";
import { Separator } from "@/shadcn-components/ui/separator";
import { formatBytes } from "@/lib/storage/calculate";
import type { AppCacheInventory, AppCacheTypeId } from "@/lib/storage/inventory";

interface AppCacheDetailViewProps {
  app: AppCacheInventory;
  onClearType: (type: AppCacheTypeId) => void;
  onClearAll: () => void;
}

export function AppCacheDetailView({
  app,
  onClearType,
  onClearAll,
}: AppCacheDetailViewProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between font-medium">
            <span>Total app cache</span>
            <span className="font-mono">{formatBytes(app.totalBytes)}</span>
          </div>
          <p className="text-sm text-muted-foreground mt-2">
            Settings, watchlists, chart preferences, and other data stored on
            this device. Your trading accounts are not removed.
          </p>
        </CardContent>
      </Card>

      <div>
        <h3 className="text-muted-foreground text-sm uppercase font-medium tracking-wide mb-3">
          MODULES
        </h3>
        <Card>
          <CardContent className="p-0">
            {app.types.map((row, i) => (
              <div key={row.id}>
                {i > 0 && <Separator />}
                <Button
                  variant="ghost"
                  onClick={() => onClearType(row.id as AppCacheTypeId)}
                  disabled={row.bytes === 0}
                  className="w-full h-auto p-3 justify-between hover:bg-muted/50 rounded-none"
                >
                  <span className="text-sm">{row.label}</span>
                  <div className="flex items-center gap-2">
                    <Badge variant="secondary" className="font-mono text-xs">
                      {formatBytes(row.bytes)}
                    </Badge>
                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                  </div>
                </Button>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="p-0">
          <Button
            variant="ghost"
            onClick={onClearAll}
            className="w-full h-auto p-3 text-destructive hover:text-destructive hover:bg-muted/50 rounded-lg"
          >
            Clear all app cache
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
